import classes from "../ApplicationComissionInfo.module.css";

export const ApplicationComissionName = (
  props: React.HTMLAttributes<HTMLDivElement>,
) => {
  const concatClassName = `${classes.infoName} ${props.className}`;
  return (
    <div {...props} className={concatClassName}>
      {props.children}
    </div>
  );
};
